export const SALE_STATUS = {
  A_FEW_LEFT: "aFewLeft",
  BEFORE_SALE: "beforeSale",
  END: "end",
  NEW: "new",
  ON_SALE: "onSale",
  SOLD_OUT: "soldOut",
} as const;
